{
	"title": "Recordings",
	"list": {
		"sectionTitle": "Recordings",
		"title": "All recordings",
		"empty": "No recordings",
		"newRecording": "New recording",
		"errorTitle": "Failed to load recordings",
		"errorDescription": "Check your connection and try again.",
		"retry": "Retry",
		"count": "{count, plural, one {# recording} other {# recordings}}",
		"subtitle": "Transcription, speaker separation and a note from every lecture",
		"emptyTitle": "No recordings yet",
		"emptyDescription": "Record a lecture — we'll transcribe it, split by speakers, and produce a note.",
		"startRecording": "Start recording",
		"pendingUpload": "A recording is waiting for network — resume upload when Wi-Fi is available",
		"continueUpload": "Resume",
		"liveNow": "Recording in progress right now",
		"liveOpen": "Open",
		"swipeDelete": "Delete",
		"swipeNote": "Note",
		"listen": "Listen",
		"searchPlaceholder": "Search by title",
		"searchEmptyTitle": "Nothing found",
		"searchEmptyDescription": "No recordings match “{query}”. Change the query or filter.",
		"filterAll": "All",
		"chunksProgress": "{uploaded} of {total} chunks uploaded"
	},
	"recorder": {
		"ready": "Ready to record",
		"readyHint": "Press the button to begin. Transcription runs in real time.",
		"recording": "Recording",
		"paused": "Paused",
		"duration": "{minutes}:{seconds}",
		"levelLabel": "Microphone level",
		"actions": {
			"start": "Start recording",
			"starting": "Starting…",
			"pause": "Pause",
			"resume": "Resume",
			"stop": "Stop",
			"stopping": "Stopping…",
			"processing": "Processing…",
			"discard": "Discard"
		},
		"banner": {
			"recording": "Recording",
			"paused": "Paused",
			"speakers": "{count, plural, one {# speaker} other {# speakers}}",
			"online": "online",
			"offline": "offline",
			"return": "Return"
		},
		"settings": {
			"title": "Recording options",
			"diarization": "Detect speakers",
			"diarizationHint": "Lines will be split by speaker"
		},
		"micSource": {
			"label": "Microphone source",
			"placeholder": "Choose a microphone",
			"empty": "No microphones found",
			"revealNames": "Reveal device names",
			"switchFailed": "Couldn't switch microphone"
		},
		"permissionNeeded": "Microphone access required",
		"permissionDenied": "Microphone access denied",
		"startFailed": "Couldn't start the recording",
		"continueFailed": "Couldn't continue the recording",
		"finalizeFailed": "Couldn't finish the recording",
		"defaultTitle": "Recording from {date}",
		"lockScreenHint": "Recording will continue on locked screen",
		"lockScreenHintUnsupported": "Don't lock the screen — recording will stop",
		"close": "Close",
		"minimize": "Minimize",
		"stopAndClose": "Stop and close",
		"back": "Back",
		"titleEdit": "Edit title",
		"titlePlaceholder": "Recording title",
		"renameError": "Couldn't rename",
		"exitConfirm": {
			"title": "Interrupt recording?",
			"description": "You can save and start processing now, or discard the recording without processing.",
			"action": "Stop and exit",
			"stopAndProcess": "Stop and process",
			"discard": "Discard recording",
			"cancel": "Continue recording"
		},
		"queue": {
			"pending": "{count, plural, one {# chunk} other {# chunks}} queued",
			"pendingTitle": "Recording chunks waiting to upload",
			"finalizePending": "You're offline — {count, plural, one {# chunk} other {# chunks}} not uploaded yet. The recording will finish automatically once they're sent.",
			"forceFinalize": "Finish without them",
			"forceFinalizing": "Finishing…",
			"allUploaded": "All chunks uploaded — processing the recording",
			"dropped": "Failed to upload {count, plural, one {# chunk} other {# chunks}} — the recording was processed without them",
			"undeliverable": "Couldn't store a recording chunk locally. Finish manually (“Finish without them”) or start a new recording."
		},
		"noChunksWarning": "The mic is picking up sound, but no recording chunks are being created. Stop and start again — otherwise the lecture won’t be saved."
	},
	"notes": {
		"title": "In-lecture notes",
		"addAt": "Note at {at}",
		"placeholder": "Note at {at}",
		"save": "Save",
		"empty": "Notes will help you find the moment later.",
		"unsaved": "unsaved",
		"unsavedHint": "Note didn't reach the server. Will retry later.",
		"delete": "Delete"
	},
	"detail": {
		"allRecordings": "All recordings",
		"loadError": "Failed to load recording",
		"notFoundTitle": "Recording not found",
		"notFoundDescription": "It’s not in your list — it may not have been saved or was deleted. Go back to all recordings.",
		"retry": "Retry",
		"stalled": {
			"title": "Recording interrupted",
			"description": "The recording was interrupted — the page was likely reloaded or the tab closed. The recognized text is saved. You can continue the same lecture, finish processing, or delete the recording.",
			"failedTitle": "Recording not processed",
			"failedDescription": "Processing didn't finish. The recognized text is saved — you can reprocess or delete the recording.",
			"continue": "Continue recording",
			"continuing": "Connecting microphone…",
			"continueToast": "Continuing the same lecture",
			"continueError": "Couldn't continue recording",
			"reprocess": "Reprocess",
			"reprocessing": "Starting…",
			"reprocessToast": "Restarting processing…",
			"reprocessError": "Couldn't restart processing",
			"finalize": "Finish and process",
			"finalizing": "Processing…",
			"delete": "Delete recording",
			"finalizeToast": "Starting recording processing…",
			"finalizeError": "Failed to start processing",
			"deleteToast": "Recording deleted",
			"deleteError": "Failed to delete recording"
		},
		"speakersCount": "{count, plural, one {# speaker} other {# speakers}}",
		"speakersTitle": "Speakers:",
		"speakerLabel": "Speaker {letter}",
		"speakerNumbered": "Speaker {number}",
		"player": {
			"title": "Lecture audio",
			"play": "Play",
			"pause": "Pause",
			"rewind": "Back 15 seconds",
			"forward": "Forward 15 seconds",
			"unavailable": "Audio unavailable — processing not finished yet."
		},
		"transcriptTitle": "Transcript",
		"transcriptCount": "{count, plural, one {# line} other {# lines}}",
		"transcriptEmpty": "Transcript is empty for now. Will be ready once processing completes.",
		"jumpToSegment": "Jump to {time}",
		"note": {
			"title": "Lecture notes",
			"emptyHint": "Create a structured note from this lecture — with headings, formulas and key points.",
			"create": "Create note",
			"creating": "Generating note…",
			"queuedToast": "Generation queued. We'll open the note when it's ready.",
			"open": "Open",
			"openNote": "Open note",
			"version": "version {version}",
			"regenerate": "Regenerate",
			"regenerateShort": "Redo",
			"ready": "Note is ready",
			"failed": "Failed to start generation"
		},
		"menu": {
			"open": "Open",
			"actions": "Recording actions",
			"generateNote": "Create note",
			"delete": "Delete recording",
			"deleteConfirm": "Delete this recording? You can restore it from trash within 30 days.",
			"deleteTitle": "Delete recording?",
			"deleteCancel": "Cancel",
			"deletedToast": "Recording deleted",
			"deleteFailed": "Failed to delete"
		}
	},
	"doc": {
		"tabLive": "Notes",
		"tabDoc": "Document",
		"tabTranscript": "Transcript",
		"docTitle": "Notes",
		"building": "The notes are being built in real time as you record…",
		"empty": "A structured note for this recording hasn't been built yet.",
		"jumpTo": "Jump to {time}",
		"audioUnsupported": "Your browser does not support audio."
	},
	"export": {
		"download": "Download",
		"menuTitle": "Download recording",
		"transcriptTxt": "Transcript (.txt)",
		"documentMd": "Notes (.md)",
		"audioMp3": "Audio (.mp3)",
		"audioPreparing": "Preparing audio…",
		"audioPreparingToast": "MP3 is being prepared — we'll let you know when it's ready",
		"audioReady": "Audio is ready to download",
		"audioReadyAction": "Download",
		"audioFallback": "MP3 unavailable — downloading the original file (WAV/WebM)",
		"failed": "Failed to download the file",
		"fallbackName": "recording"
	},
	"transcription": {
		"title": "Transcript",
		"inProgress": "Transcribing…",
		"ready": "Transcript ready",
		"failed": "Transcription failed",
		"speaker": "Speaker {n}",
		"liveTitle": "Live transcript",
		"liveBadge": "Live",
		"liveEmpty": "Transcript will appear here once recording starts.",
		"liveStarting": "The first lines will appear 10–20 seconds after speech begins."
	},
	"postProcess": {
		"title": "Post-processing",
		"notesReady": "Notes ready",
		"flashcardsReady": "Flashcards ready",
		"summaryReady": "Summary ready"
	},
	"processing": {
		"title": "Processing recording…",
		"tip": "You can close the page — we'll send a notification when it's ready.",
		"stages": {
			"merging-chunks": "Merging chunks",
			"diarizing": "Separating speakers",
			"transcribing": "Transcribing speech",
			"post-processing": "Cleanup and formatting"
		}
	},
	"manualNotes": {
		"title": "In-lecture notes",
		"addNote": "Add note",
		"placeholder": "Note at {timestamp}",
		"jumpTo": "Jump to {timestamp}"
	},
	"upload": {
		"selectAudio": "Upload audio",
		"selectVideo": "Upload video"
	},
	"intro": {
		"title": "Transcription runs during the lecture",
		"body": "Text appears as you record, not afterwards. Here sound turns into text; the opposite direction lives in audio recaps.",
		"bullets": [
			"A note taken while recording pins to the second",
			"If the link drops, the missing chunks upload later",
			"Microphone only: a ready file belongs in the library"
		]
	}
}
